// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export class AccountOperationReport
{
    get IsTrading () { return this.OperationTypeId === 1; }

    constructor()
    {
        this.AccountId = "";
        this.AccountName = "";
        this.InstrumentTradableID = 0;
        this.TradableInstrumentName = "";
        this.Date = 0;
        this.OperationTypeId = 0;
        this.OperationTypeName = "";
        this.OperationID = "";
        this.OpenPrice = "";
        this.ClosePrice = "";
        this.Amount = 0;
        this.CurrencyName = "";
        this.IsBuy = false;
        this.Quantity = 0;
        this.Instrument = null;
    }
}